import { VIEW_KIND_SECTION } from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
import type { LocalViewId } from '@jira/polaris__domain-view/src/ViewKind.types.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { withRefreshBlocker } from './withRefreshBlocker.tsx';
import { updateContainerState } from './updateContainerState.tsx';

export const createViewSet = (localId: LocalViewId, name: string): Action<State, Props> =>
	withRefreshBlocker(
		async (
			{ setState, getState },
			{ navigationRemote, cloudId, containerId, onFailure, onSuccess, containerType },
		) => {
			if (
				!cloudId ||
				!containerId ||
				!navigationRemote ||
				getState().containers[containerId]?.isLoading ||
				!getState().containers[containerId]?.initialized
			) {
				return;
			}

			setState(
				updateContainerState(getState(), containerId, {
					views: [
						...getState().containers[containerId].views.map((view) =>
							view.localId === localId
								? {
										...view,
										name,
										isManuallyCreated: true,
										isLocked: true,
										isExpanded: false,
										isRenaming: false,
									}
								: view,
						),
					],
				}),
			);

			try {
				const remoteViewSet = await navigationRemote.createView({
					containerId,
					name,
					parentId: containerId,
					parentType: containerType,
					viewType: VIEW_KIND_SECTION,
				});
				setState(
					updateContainerState(getState(), containerId, {
						views: [
							...getState().containers[containerId].views.map((view) =>
								view.localId === localId
									? {
											...view,
											id: remoteViewSet.id,
											polarisId: remoteViewSet.polarisId,
											name: remoteViewSet.name,
											isLocked: false,
										}
									: view,
							),
						],
					}),
				);
				onSuccess?.('createSection');
				// oxlint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				setState(
					updateContainerState(getState(), containerId, {
						views: [
							...getState().containers[containerId].views.map((view) =>
								view.localId === localId ? { ...view, isLocked: false } : view,
							),
						],
					}),
				);

				onFailure?.(error, 'createSection');
			}
		},
	);
